type NativeActionPayload = {
  action: string;
  [key: string]: unknown;
};

declare global {
  interface Window {
    AndroidBridge?: { handleAction: (data: string) => void };
    webkit?: {
      messageHandlers?: {
        iOSBridge?: { postMessage: (data: string) => void };
      };
    };
    __SUPPORTED_NATIVE_SCREENS__?: string[];
  }
}

export function isInWebview(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  return Boolean(window.AndroidBridge?.handleAction || window.webkit?.messageHandlers?.iOSBridge);
}

export function triggerNativeAction(payload: NativeActionPayload): void {
  if (!isInWebview()) {
    return;
  }

  const data = JSON.stringify(payload);
  if (window.AndroidBridge?.handleAction) {
    window.AndroidBridge.handleAction(data);
  } else {
    window.webkit?.messageHandlers?.iOSBridge?.postMessage(data);
  }
}

// Raw strings injected by the native app — untrusted and not guaranteed to map to a known
// WebviewScreenId, so callers should treat this as an opaque allow-list for `includes` checks only.
export function getInjectedSupportedScreens(): readonly string[] | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return window.__SUPPORTED_NATIVE_SCREENS__ ?? null;
}
